import { useQuery, useMutation } from "@tanstack/react-query";
import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";
import {
  UserReserveCompanyListRequest,
  UserReserveCompanyListResponse,
  UserReserveNoticeReadRequest,
  UserReserveNoticeReadResponse,
} from "~/types/common";

// User Reserve Company List 조회
const getUserReserveCompanyList = async (
  params: UserReserveCompanyListRequest
): Promise<UserReserveCompanyListResponse> => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.RESERVATION.COMPANY_LIST,
      { params }
    );
    return data;
  } catch (error) {
    console.error("사용자 예약 업체 목록 조회 API 호출 에러:", error);
    throw error;
  }
};

export const useUserReserveCompanyList = () => {
  return useQuery({
    queryKey: ["user-reserve-company-list"],
    queryFn: () => getUserReserveCompanyList({}),
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
  });
};

// User Reserve Notice Read 조회
const getUserReserveNoticeRead = async (
  params: UserReserveNoticeReadRequest
): Promise<UserReserveNoticeReadResponse> => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.RESERVATION.NOTICE_READ,
      { params }
    );
    return data;
  } catch (error) {
    console.error("사용자 예약 알림 읽음 처리 API 호출 에러:", error);
    throw error;
  }
};

export const useUserReserveNoticeRead = () => {
  return useMutation({
    mutationFn: getUserReserveNoticeRead,
  });
};
